export default "__VITE_ASSET__CcO2jUCf__"